import {registerGraph, mergeGraph} from '@/angular/modules/vrm-graph/config-utils';

registerGraph('dashboardAcMeterGraph', dashboardAcMeterGraph);

/* @ngInject */
function dashboardAcMeterGraph(GraphService, dashboardGraph) {
    const GraphColors = GraphService.colors;
    return mergeGraph(dashboardGraph(), {
        options: {
            colors: [GraphColors.lightGreen],
            yAxis: {
                min: 0
            }
        }
    });
}
